export default __webpack_public_path__ + "static/media/stream-grey.57fadc89.svg";